<template>
  <div>
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Row style="padding:10px 0px 0px 0px;margin-bottom: 10px">
      <Col span="3" style="padding:0px 5px 0px 0px">
        <Button long type="primary" @click="showModal = true">检索条件</Button>
      </Col>
      <Col span="8" style="margin-left:10px;padding:0px 5px 0px 0px">
        <h2 v-if="selectedType == 'personnel'">当前人员类型：工程人员</h2>
        <h2 v-if="selectedType == 'householder'">当前人员类型：户主用户</h2>
      </Col>
    </Row>
    <Modal title="Title" v-model="showModal" :mask-closable="false" width="380">
      <p slot="header" style="color:#ff9900;text-align:center">
        <span>检索条件</span>
      </p>
      <div style="text-align:center">
        <div style="margin-bottom: 10px">
          <Select
            v-model="selectedType"
            style="margin-left:10px; width:200px"
            placeholder="请选择用户类型"
          >
            <Option value="householder">户主用户</Option>
            <Option value="personnel">工程人员</Option>
            <!-- <Option v-if="true" value="householder">户主用户</Option>
            <Option v-if="true" value="nothouseholder">非户主用户</Option>
            <Option v-if="true" value="personnel">工程人员</Option>-->
          </Select>
        </div>
        <div>
          <Input style="margin-left:10px; width:200px;" v-model="idCard" placeholder="请输入证件号"></Input>
        </div>
      </div>
      <div slot="footer">
        <Button :loading="isLoading" type="warning" size="large" @click="selectTypeClick" long>确认</Button>
      </div>
    </Modal>
    <Table
      ref="selectionTable"
      :max-height="height"
      :data="showData"
      :columns="showColumns"
      stripe
      highlight-row
      border
      style="font-size:20px"
    >
      <template slot-scope="{ row, index }" slot="wx">
        <div>
          <span v-if="row.nickname != undefined" style="marin-left: 10px;">{{row.nickname}}</span>
          <img
            v-if="row.headimgurl != undefined"
            :src="row.headimgurl"
            style="width:20px;margin-left:10px"
          />
          <span v-if="row.nickname == undefined">未绑定</span>
        </div>
      </template>
      <template slot-scope="{ row, index }" slot="debind">
        <Button
          type="warning"
          :disabled="row.openid==undefined"
          shape="circle"
          @click="debind(selectedType, row)"
        >解除绑定</Button>
      </template>
    </Table>
    <Row style="padding:10px 0px 0px 0px">
      <!-- <Col span="3" style="padding:0px 5px 0px 0px">
        <Button long type="success" @click="onClickInsert">添加{{typeName}}</Button>
      </Col>-->
      <!-- <Col span="3" style="padding:0px 5px 0px 0px">
        <Button long type="warning" @click="onClickUpdate">解绑{{typeName}}</Button>
      </Col>-->
      <!-- <Col span="3" style="padding:0px 5px 0px 0px">
        <Button long type="error" @click="onClickDelete">删除{{typeName}}</Button>
      </Col>-->
      <Col span="15">
        <Page
          :current="currentPage"
          :total="dataCount"
          :page-size="pageSize"
          show-sizer
          show-total
          @on-change="changePage"
          @on-page-size-change="changePageSize"
          style="text-align:right"
        ></Page>
      </Col>
    </Row>
    <!-- 模态框update -->
    <Modal v-model="isShowUpdateModal" :mask-closable="false" width="380">
      <p slot="header" style="color:#ff9900;text-align:center">
        <Icon type="md-create" />
        <span>修改{{typeName}}</span>
      </p>
      <Form ref="formUpdate" :label-width="110" :rules="ruleInsert" :model="formUpdate">
        <FormItem prop="xxxx" label="xxxx：">
          <Input v-model="formUpdate.xxxx" placeholder="请输入xxxx..."></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="warning" size="large" long :loading="isLoadingButton" @click="commitUpdate">修改</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  mounted() {
    this.showColumns = [
      {
        title: "姓名",
        key: "customerName",
        align: "center"
      },
      {
        title: "证件号",
        key: "customerIdcard",
        align: "center"
      },
      {
        title: "联系方式",
        key: "customerPhone",
        align: "center"
      },
      {
        title: "微信信息",
        slot: "wx",
        align: "center"
      },
      {
        title: " ",
        slot: "debind",
        align: "center"
      }
    ];
    // this.showPage();
    this.selectTypeClick();
  },
  data() {
    const validateyyyy = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error("请输入yyyy..."));
      } else {
        callback();
      }
    };
    return {
      typeName: "微信",
      urlClass: "",
      height: window.innerHeight,
      isSpinShow: false,
      isLoading: false,
      isLoadingButton: false,
      isShowInsertModal: false,
      isShowUpdateModal: false,
      isShowDeleteModal: false,
      isShowTarget: false,
      isSpinShow: false,
      currentPage: 1,
      dataCount: 0,
      pageSize: 10,
      showData: [],
      showColumns: [],
      selectedData: null,
      formInsert: {},
      formUpdate: {},
      idCard: "",
      showModal: false,
      selectedType: "personnel",
      ruleInsert: {
        xxxx: [
          {
            required: true,
            message: "请输入xxxx...",
            trigger: "blur"
          }
        ],
        yyyy: [
          {
            required: true,
            validator: validateyyyy,
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    debind(type, object) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>请确认是否要解绑当前用户？</p>",
        onOk: () => {
          this.isSpinShow = true;
          var that = this;
          console.log(object);
          $.ajax({
            url: "/api/deBind",
            contentType: "application/json",
            type: "post",
            data: JSON.stringify({
              type: type,
              object: object
            }),
            dataType: "json",
            success: function(data) {
              if (data.errorCode != 0) {
                that.$Modal.error({
                  title: "提示",
                  content: data.errorInfo
                });
                return;
              } else {
                // 当前用户微信未进行绑定
                that.$Modal.success({
                  title: "提示",
                  content: "解除绑定成功"
                });
                // that.callBack(data);
              }
              console.log(data);
            },
            error: function(textStatus) {
              that.$Notice.error({
                title: "异常",
                desc: "接口调用异常"
              });
            },
            complete: function(XMLHttpRequest, textStatus) {
              that.showPage();
              that.isSpinShow = false;
            }
          });
        },
        onCancel: () => {}
      });
    },
    onSelectionTableChange(currentRow) {
      this.selectedData = currentRow;
    },
    onClickInsert() {
      this.isShowInsertModal = true;
    },
    onClickUpdate() {
      if (this.selectedData) {
        this.formUpdate = this.selectedData;
        this.isShowUpdateModal = true;
      } else {
        this.$Notice.warning({
          title: "警告",
          desc: "请选择一条数据！"
        });
      }
    },
    onClickDelete() {
      if (this.selectedData) {
        this.isShowDeleteModal = true;
      } else {
        this.$Notice.warning({
          title: "警告",
          desc: "请选择一条数据！"
        });
      }
    },
    commitInsert() {
      let that = this;
      that.$refs["formInsert"].validate(valid => {
        if (valid) {
          that.isLoadingButton = true;
          $.ajax({
            url: "/api/" + that.urlClass + "/insert",
            contentType: "application/json",
            type: "post",
            data: JSON.stringify(that.formInsert),
            dataType: "json",
            success: function(data) {
              if (data.errorCode != 0) {
                that.$Notice.error({
                  title: "异常",
                  desc: data.errorInfo
                });
                return;
              }
              that.showPage();
            },
            error: function(textStatus) {
              that.$Notice.error({
                title: "异常",
                desc: "接口请求异常"
              });
            },
            complete: function() {
              that.isLoadingButton = false;
              that.isShowInsertModal = false;
            }
          });
        }
      });
    },
    commitUpdate() {
      let that = this;
      that.$refs["formUpdate"].validate(valid => {
        if (valid) {
          that.isLoadingButton = true;
          $.ajax({
            url: "/api/" + that.urlClass + "/update",
            contentType: "application/json",
            type: "post",
            data: JSON.stringify(that.formUpdate),
            dataType: "json",
            success: function(data) {
              if (data.errorCode != 0) {
                that.$Notice.error({
                  title: "异常",
                  desc: data.errorInfo
                });
                return;
              }
              that.showPage();
            },
            error: function(textStatus) {
              that.$Notice.error({
                title: "异常",
                desc: "接口请求异常"
              });
            },
            complete: function() {
              that.isLoadingButton = false;
              that.isShowUpdateModal = false;
            }
          });
        }
      });
    },
    commitDelete() {
      let that = this;
      that.isLoadingButton = true;
      $.ajax({
        url: "/api/" + that.urlClass + "/delete",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(that.selectedData),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          that.showPage();
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.isLoadingButton = false;
          that.isShowDeleteModal = false;
        }
      });
    },
    showPage() {
      let that = this;
      that.isSpinShow = true;
      $.ajax({
        url:
          "/api/getUserInfoWithWxInfo?page=" +
          that.currentPage +
          "&pageAmount=" +
          that.pageSize,
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          type: that.selectedType,
          idCard: that.idCard
        }),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          console.log(data);
          that.showData = data.body.infoArray;
          that.dataCount = data.body.count;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.isSpinShow = false;
        }
      });
    },
    changePage(index) {
      this.currentPage = index;
      this.showPage();
    },
    changePageSize(size) {
      this.pageSize = size;
      this.showPage();
    },
    selectTypeClick() {
      this.showModal = false;
      if (this.selectedType != "personnel") {
        this.showColumns = [
          {
            title: "姓名",
            key: "customerName",
            align: "center"
          },
          {
            title: "证件号",
            key: "customerIdcard",
            align: "center"
          },
          {
            title: "联系方式",
            key: "customerPhone",
            align: "center"
          },
          {
            title: "微信信息",
            slot: "wx",
            align: "center"
          },
          {
            title: " ",
            slot: "debind",
            align: "center"
          }
        ];
      } else {
        this.showColumns = [
          {
            title: "姓名",
            key: "personnelName",
            align: "center"
          },
          {
            title: "证件号",
            key: "personnelIdcard",
            align: "center"
          },
          {
            title: "联系方式",
            key: "personnelPhone",
            align: "center"
          },
          {
            title: "微信信息",
            slot: "wx",
            align: "center"
          },
          {
            title: " ",
            slot: "debind",
            align: "center"
          }
        ];
      }
      this.showPage();
    }
  }
};
</script>

<style>
</style>
